<template>
  <div class="status" :class="[getStatus, { legend }]">
    <div v-if="intake?.status === 'rejected'" class="rejected-icon">
      <v-icon color="white">mdi-close</v-icon>
    </div>

    <div v-else>
      <slot></slot>
      <div v-if="intake?.doseMg" class="text-center dose-text">
        {{ intake?.doseMg }} mg
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    intake: {
      type: [Object || undefined],
      required: false,
    },
    legend: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    getStatus() {
      if (this.intake) {
        return `${this.intake.status}-${this.intake.dosageType}`;
      } else {
        return "empty";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dose-text {
  font-size: 0.75rem;
  margin-top: 0.25rem;
  text-align: center;
  color: gray;
}

.status {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;

  &.accepted-norditropin5Mg {
    border-top: 4px solid #faa231;
    background-color: #fef4e6;
  }

  &.accepted-norditropin10Mg {
    border-top: 4px solid #02a6de;
    background-color: #e6f5fc;
  }

  &.accepted-norditropin15Mg {
    border-top: 4px solid #93bb4e;
    background-color: #f2f7e9;
  }

  .rejected-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    background-color: #ff7879;
  }

  &.empty {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    background-color: gainsboro;
  }

  &.legend {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;

    &.accepted-norditropin5Mg {
      border: 4px solid #faa231;
      background-color: transparent;
    }

    &.accepted-norditropin10Mg {
      border: 4px solid #02a6de;
      background-color: transparent;
    }

    &.accepted-norditropin15Mg {
      border: 4px solid #93bb4e;
      background-color: transparent;
    }

    &.rejected-norditropin5Mg,
    &.rejected-norditropin10Mg,
    &.rejected-norditropin15Mg {
      background-color: #ff7879;
      color: white;
      border: none;
    }
  }
}
</style>
